"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createSchemaFormPage = exports.createSchemaForm = exports.useModalForm = exports.SchemaFormInternal = void 0;
const react_1 = __importStar(require("react"));
const react_hook_form_1 = require("react-hook-form");
const Spinner_1 = __importDefault(require("react-bootstrap/Spinner"));
const react_router_dom_1 = require("react-router-dom");
const core_1 = require("react-hook-schema/core");
const standard_1 = require("react-hook-schema/standard");
const react_bootstrap_1 = require("react-bootstrap");
require("./SchemaForm.scss");
const url_1 = require("utils/url");
const hooks_1 = require("common/hooks");
const components_1 = require("utils/components");
const react_split_1 = __importDefault(require("@uiw/react-split"));
const log_1 = require("common/log");
const SchemaFormInternal = ({ schemaComponents, data, readOnly, parameter, accessorRef, }) => {
    const Field = (0, core_1.createSelector)(schemaComponents);
    const alert = (0, standard_1.useAlert)();
    const [isPending, setIsPending] = (0, react_1.useState)(false);
    const formMethods = (0, react_hook_form_1.useForm)({
        defaultValues: data,
    });
    const { handleSubmit, control, formState, reset, getValues, watch, trigger } = formMethods;
    if (accessorRef) {
        accessorRef.current = {
            get: () => getValues(),
            set: (value) => reset(value),
        };
    }
    const navigate = (0, react_router_dom_1.useNavigate)();
    const { back, edit, remove, next, schema, preview, enableFormAlert, backPath, extraSchema, } = parameter;
    const hasErrors = enableFormAlert && Object.keys(formState.errors).length > 0;
    const confirm = (0, standard_1.useConfirm)();
    const errorModal = (0, standard_1.useErrorModal)();
    const clickSubmit = (value) => __awaiter(void 0, void 0, void 0, function* () {
        var _a;
        if ((edit === null || edit === void 0 ? void 0 : edit.confirm) !== false) {
            const result = yield confirm({
                message: (edit === null || edit === void 0 ? void 0 : edit.confirm) || "保存しますか？",
            });
            if (!result)
                return;
        }
        try {
            setIsPending(true);
            const record = yield ((_a = edit === null || edit === void 0 ? void 0 : edit.handler) === null || _a === void 0 ? void 0 : _a.call(edit, value));
            const path = (typeof (edit === null || edit === void 0 ? void 0 : edit.path) === "function" ? edit.path(record) : edit === null || edit === void 0 ? void 0 : edit.path) ||
                backPath;
            path && navigate(path);
        }
        catch (e) {
            console.error("Error while submit in edit handler", e);
            if (e instanceof Error) {
                alert({ message: e.message });
                (0, log_1.errorLog)(e);
            }
            else {
                errorModal({
                    error: e,
                    userMessage: "更新時のエラーです。通常は発生しないエラーのため、管理者にお問合せください。",
                });
            }
        }
        finally {
            setIsPending(false);
        }
    });
    const clickDelete = () => __awaiter(void 0, void 0, void 0, function* () {
        var _b;
        if ((remove === null || remove === void 0 ? void 0 : remove.confirm) !== false) {
            const result = yield confirm({
                message: (remove === null || remove === void 0 ? void 0 : remove.confirm) || "削除しますか？",
            });
            if (!result)
                return;
        }
        try {
            setIsPending(true);
            yield ((_b = remove === null || remove === void 0 ? void 0 : remove.handler) === null || _b === void 0 ? void 0 : _b.call(remove));
            const path = (remove === null || remove === void 0 ? void 0 : remove.path) || backPath;
            path && navigate(path);
        }
        catch (e) {
            errorModal({
                error: e,
                internalMessage: "Error while removing",
                userMessage: "削除時のエラーです。通常は発生しないエラーのため、管理者にお問合せください。",
            });
        }
        finally {
            setIsPending(false);
        }
    });
    const clickBack = () => __awaiter(void 0, void 0, void 0, function* () {
        var _c;
        if (back === null || back === void 0 ? void 0 : back.confirm) {
            const result = yield confirm({
                message: back === null || back === void 0 ? void 0 : back.confirm,
            });
            if (!result)
                return;
        }
        try {
            setIsPending(true);
            yield ((_c = back === null || back === void 0 ? void 0 : back.handler) === null || _c === void 0 ? void 0 : _c.call(back));
            const path = (back === null || back === void 0 ? void 0 : back.path) || backPath;
            path && navigate(path);
        }
        catch (e) {
            errorModal({
                error: e,
                internalMessage: "Error click back",
                userMessage: "ページ戻り時のエラーです。通常は発生しないエラーのため、管理者にお問合せください。",
            });
        }
        finally {
            setIsPending(false);
        }
    });
    const clickNext = () => __awaiter(void 0, void 0, void 0, function* () {
        if (!(next === null || next === void 0 ? void 0 : next.condition) || next.condition(watch())) {
            next === null || next === void 0 ? void 0 : next.handler(watch());
        }
    });
    return (react_1.default.createElement(react_hook_form_1.FormProvider, Object.assign({}, formMethods),
        react_1.default.createElement(react_bootstrap_1.Modal, { show: isPending },
            react_1.default.createElement(react_bootstrap_1.Modal.Header, null,
                react_1.default.createElement(react_bootstrap_1.Modal.Title, null, "\u8AAD\u307F\u8FBC\u307F\u4E2D\u3067\u3059")),
            react_1.default.createElement(react_bootstrap_1.Modal.Body, null,
                react_1.default.createElement("p", null, "\u3057\u3070\u3089\u304F\u304A\u5F85\u3061\u304F\u3060\u3055\u3044"))),
        react_1.default.createElement("div", { className: "tile" },
            react_1.default.createElement("div", { className: "card tile" },
                react_1.default.createElement("div", { className: "card-content" },
                    react_1.default.createElement("form", { onSubmit: handleSubmit(clickSubmit), className: "adjust-width-expand", noValidate: true },
                        !(preview === null || preview === void 0 ? void 0 : preview.isDisabled) && (preview === null || preview === void 0 ? void 0 : preview.position) === "before" && (react_1.default.createElement("div", { className: "mb-4" },
                            react_1.default.createElement(PreviewComponent, { schemaComponents: schemaComponents, preview: preview, control: control, data: watch(), accessorRef: accessorRef }))),
                        (preview === null || preview === void 0 ? void 0 : preview.position) !== "right" && (react_1.default.createElement("div", null,
                            react_1.default.createElement(Field, { control: control, schema: schema, readOnly: readOnly }))),
                        !(preview === null || preview === void 0 ? void 0 : preview.isDisabled) && (preview === null || preview === void 0 ? void 0 : preview.position) === "right" && (react_1.default.createElement(react_split_1.default, { mode: "horizontal" },
                            react_1.default.createElement("div", null,
                                react_1.default.createElement(Field, { control: control, schema: schema, readOnly: readOnly })),
                            react_1.default.createElement("div", { style: { width: "50%" } },
                                react_1.default.createElement(PreviewComponent, { schemaComponents: schemaComponents, preview: preview, control: control, data: watch(), accessorRef: accessorRef })))),
                        !(preview === null || preview === void 0 ? void 0 : preview.isDisabled) && (preview === null || preview === void 0 ? void 0 : preview.position) === "after" && (react_1.default.createElement(PreviewComponent, { schemaComponents: schemaComponents, preview: preview, control: control, data: watch(), accessorRef: accessorRef })),
                        extraSchema && (react_1.default.createElement(Field, { control: control, schema: extraSchema, readOnly: readOnly })),
                        !readOnly && (react_1.default.createElement(react_1.default.Fragment, null,
                            (edit || remove || back || backPath) && react_1.default.createElement("hr", null),
                            edit && hasErrors && (react_1.default.createElement(react_bootstrap_1.Alert, { variant: "danger" }, "\u672A\u5165\u529B\u306E\u9805\u76EE\u304C\u3042\u308A\u307E\u3059\u3002\u4E0A\u306B\u30B9\u30AF\u30ED\u30FC\u30EB\u3057\u3066\u8A72\u5F53\u7B87\u6240\u3092\u4FEE\u6B63\u3057\u3066\u304F\u3060\u3055\u3044")),
                            react_1.default.createElement("div", { className: "d-flex justify-content-between align-items-center" },
                                react_1.default.createElement("div", { className: "d-flex" },
                                    edit && (react_1.default.createElement(components_1.Button, { type: "submit", className: "me-2", disabled: hasErrors ||
                                            !formState.isDirty ||
                                            formState.isSubmitting, loading: formState.isSubmitting }, (edit === null || edit === void 0 ? void 0 : edit.title) || "更新を保存")),
                                    remove && (react_1.default.createElement(components_1.Button, { onClick: clickDelete, type: "button", variant: "danger", className: "me-2" }, remove.title || "削除")),
                                    (back || backPath) && (react_1.default.createElement(components_1.Button, { onClick: clickBack, type: "button", variant: "primary", className: "me-2" }, (back === null || back === void 0 ? void 0 : back.title) || "もどる"))),
                                next && (react_1.default.createElement(components_1.Button, { onClick: clickNext, type: "button", variant: "primary" }, next.title || "次へ")))))))),
            !(preview === null || preview === void 0 ? void 0 : preview.isDisabled) && (preview === null || preview === void 0 ? void 0 : preview.position) === undefined && (react_1.default.createElement(PreviewComponent, { schemaComponents: schemaComponents, control: control, preview: preview, data: watch(), accessorRef: accessorRef })))));
};
exports.SchemaFormInternal = SchemaFormInternal;
const SchemaFormPageInternal = ({ schemaComponents, data, parameter, loading, readOnly, editModeEnabled, header, }) => {
    var _a, _b, _c;
    const { title, subtitle } = parameter;
    const { copy, paste } = (0, standard_1.useCopyPaste)({
        objectType: (_a = parameter.clipboard) === null || _a === void 0 ? void 0 : _a.objectType,
        ignoreKeys: (_b = parameter.clipboard) === null || _b === void 0 ? void 0 : _b.ignoreKeys,
    });
    const confirm = (0, standard_1.useConfirm)();
    const accessorRef = react_1.default.useRef(null);
    const searchParamAccessor = (0, url_1.useSearchParamAccessor)();
    const { value: editMode, setValue: setEditMode } = (0, hooks_1.useFieldAccessor)(searchParamAccessor, "edit");
    const navigate = (0, react_router_dom_1.useNavigate)();
    console.log("editModeEnabled", editModeEnabled, editMode, parameter.edit);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(components_1.PageHeader, { title: title !== null && title !== void 0 ? title : "" }, ((_c = parameter.header) === null || _c === void 0 ? void 0 : _c.isStacked) ||
            (parameter === null || parameter === void 0 ? void 0 : parameter.clipboard) ||
            editModeEnabled ? (react_1.default.createElement(react_bootstrap_1.Stack, { direction: "horizontal", gap: 3 },
            react_1.default.createElement("h2", { className: "subtitle" }, subtitle),
            react_1.default.createElement("div", { className: "ms-auto", style: { display: "flex" } },
                !loading &&
                    parameter.clipboard &&
                    !parameter.clipboard.isDisabled && (react_1.default.createElement(components_1.Button, { style: { marginLeft: "5px" }, onClick: () => __awaiter(void 0, void 0, void 0, function* () {
                        var _d;
                        copy(yield ((_d = accessorRef.current) === null || _d === void 0 ? void 0 : _d.get()));
                    }), variant: "primary", "data-tooltip-id": "tooltip", "data-tooltip-content": "\u30B3\u30D4\u30FC" },
                    react_1.default.createElement("i", { className: "mdi mdi-content-copy" }))),
                !loading &&
                    parameter.clipboard &&
                    !parameter.clipboard.isDisabled &&
                    ((editModeEnabled && editMode) || !editModeEnabled) && (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement(components_1.Button, { style: { marginLeft: "5px" }, onClick: () => __awaiter(void 0, void 0, void 0, function* () {
                            var _e, _f, _g, _h;
                            const currentValue = (_e = accessorRef.current) === null || _e === void 0 ? void 0 : _e.get();
                            const retainedValue = Object.fromEntries(((_g = (_f = parameter.clipboard) === null || _f === void 0 ? void 0 : _f.retainKeys) === null || _g === void 0 ? void 0 : _g.map((key) => [
                                key,
                                currentValue === null || currentValue === void 0 ? void 0 : currentValue[key],
                            ])) || []);
                            const clipBoardData = yield paste();
                            if (!clipBoardData)
                                return;
                            (_h = accessorRef.current) === null || _h === void 0 ? void 0 : _h.set(Object.assign(Object.assign({}, clipBoardData), retainedValue));
                        }), variant: "primary", "data-tooltip-id": "tooltip", "data-tooltip-content": "\u8CBC\u308A\u4ED8\u3051" },
                        react_1.default.createElement("i", { className: "mdi mdi-content-paste" })))),
                editModeEnabled && editMode && (react_1.default.createElement(components_1.Button, { style: { marginLeft: "5px" }, variant: "primary", onClick: () => __awaiter(void 0, void 0, void 0, function* () {
                        var _j;
                        const result = yield confirm({
                            message: "破棄しますか？",
                        });
                        if (!result)
                            return;
                        (_j = accessorRef.current) === null || _j === void 0 ? void 0 : _j.set(data);
                        setEditMode(undefined);
                    }), "data-tooltip-id": "tooltip", "data-tooltip-content": "\u7834\u68C4\u3057\u3066\u95B2\u89A7\u753B\u9762\u306B\u623B\u308B" },
                    react_1.default.createElement("i", { className: "mdi mdi-window-close" }))),
                editModeEnabled &&
                    !editMode &&
                    parameter.edit &&
                    !parameter.edit.isDisabled && (react_1.default.createElement(components_1.Button, { style: { marginLeft: "5px" }, variant: "primary", onClick: () => __awaiter(void 0, void 0, void 0, function* () {
                        setEditMode("1");
                    }), "data-tooltip-id": "tooltip", "data-tooltip-content": "\u7DE8\u96C6" },
                    react_1.default.createElement("i", { className: "mdi mdi-pencil" }))),
                !loading && parameter.tooltip && (react_1.default.createElement(react_1.default.Fragment, null,
                    " ",
                    react_1.default.createElement(components_1.Button, { variant: "primary", "data-tooltip-id": "tooltip-click", "data-tooltip-html": parameter.tooltip &&
                            `<div class="tooltip-content">${parameter.tooltip}</div>`, style: {
                            borderRadius: "50%",
                            width: "26px",
                            height: "26px",
                            padding: "0",
                        } },
                        react_1.default.createElement("span", { className: "mdi mdi-information-variant" })))),
                parameter.history && (react_1.default.createElement(components_1.Button, { style: { marginLeft: "5px" }, variant: "primary", onClick: () => __awaiter(void 0, void 0, void 0, function* () {
                        var _k;
                        navigate(((_k = parameter.history) === null || _k === void 0 ? void 0 : _k.path) || "");
                    }), "data-tooltip-id": "tooltip", "data-tooltip-content": "\u5C65\u6B74" },
                    react_1.default.createElement("i", { className: "mdi mdi-history" })))))) : (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("h1", { className: "title" }, title),
            react_1.default.createElement("h2", { className: "subtitle" }, subtitle)))),
        react_1.default.createElement("div", { style: { padding: "0 18px" } }, header),
        react_1.default.createElement("section", null, loading ? (react_1.default.createElement("div", { style: { padding: "20px" } },
            react_1.default.createElement(Spinner_1.default, { animation: "border", role: "status" },
                react_1.default.createElement("span", { className: "visually-hidden" }, "Loading...")))) : (react_1.default.createElement(exports.SchemaFormInternal, { schemaComponents: schemaComponents, data: data, parameter: parameter, readOnly: readOnly || (editModeEnabled && !editMode), accessorRef: accessorRef })))));
};
const PreviewComponent = ({ preview, control, data, accessorRef, }) => {
    if (!preview)
        return null;
    const { title, component, isDisabled, position } = preview;
    const Preview = component;
    return (react_1.default.createElement("div", { className: "card tile" },
        react_1.default.createElement("header", { className: "card-header" },
            react_1.default.createElement("div", { className: "card-header-title" }, title)),
        react_1.default.createElement("div", { className: "card-content preview-wrapper", style: { padding: "0.5rem" } },
            react_1.default.createElement(Preview, { control: control, data: data, accessorRef: accessorRef }))));
};
const modalForm = ({ schemaComponents, onResolve, params, value, }) => {
    return (react_1.default.createElement(react_bootstrap_1.Modal, { show: true, className: "policy", onHide: () => onResolve(undefined) },
        react_1.default.createElement(react_bootstrap_1.Modal.Header, { closeButton: true }, params.title && react_1.default.createElement(react_bootstrap_1.Modal.Title, null, params.title)),
        react_1.default.createElement(react_bootstrap_1.Modal.Body, { style: { overflow: "auto", height: "70vh" } },
            react_1.default.createElement(SchemaFormPageInternal, { schemaComponents: schemaComponents, data: value || {}, parameter: Object.assign(Object.assign({}, params), { title: undefined, edit: Object.assign(Object.assign({}, params.edit), { confirm: false, handler: (value) => __awaiter(void 0, void 0, void 0, function* () {
                            onResolve(value);
                        }) }) }) }))));
};
const useModalForm = () => {
    return (0, standard_1.useModalWithRegister)(modalForm);
};
exports.useModalForm = useModalForm;
const createSchemaForm = (schemaComponents) => {
    return (props) => react_1.default.createElement(exports.SchemaFormInternal, Object.assign({}, props, { schemaComponents: schemaComponents }));
};
exports.createSchemaForm = createSchemaForm;
const createSchemaFormPage = (schemaComponents) => {
    return (props) => (react_1.default.createElement(SchemaFormPageInternal, Object.assign({}, props, { schemaComponents: schemaComponents })));
};
exports.createSchemaFormPage = createSchemaFormPage;
